import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { store, setUser, setModules, setTheme } from './store';
import { authApi, settingsApi } from './services/api';
import './styles/global.css';

import LoginPage from './pages/Login/LoginPage';
import AdminLayout from './components/layout/AdminLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import Barriers from './pages/Barriers/Barriers';
import Restaurants from './pages/Restaurants/Restaurants';
import Kitchen from './pages/Restaurants/Kitchen';
import Users from './pages/Users/Users';
import Analytics from './pages/Analytics/Analytics';
import Wallet from './pages/Wallet/Wallet';
import Settings from './pages/Settings/Settings';
import Roles from './pages/Roles/Roles';
import Announcements from './pages/Announcements/Announcements';
import Delivery from './pages/Delivery/Delivery';
import Reports from './pages/Reports/Reports';
import Services from './pages/Services/Services';

function PrivateRoute({ children }) {
  const token = useSelector(s => s.auth.token);
  return token ? children : <Navigate to="/login" replace />;
}

function AppInner() {
  const dispatch = useDispatch();
  const token = useSelector(s => s.auth.token);
  const themeMode = useSelector(s => s.theme?.mode || 'dark');

  // Apply theme on mount and change
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', themeMode);
  }, [themeMode]);

  // Apply saved theme on first load
  useEffect(() => {
    const saved = localStorage.getItem('bg_theme') || 'dark';
    dispatch(setTheme(saved));
  }, []);

  useEffect(() => {
    if (token) {
      authApi.me().then(data => dispatch(setUser(data))).catch(() => {});
    }
    // Modulları həmişə yüklə (public endpoint)
    settingsApi.getModules()
      .then(data => dispatch(setModules(Array.isArray(data) ? data : [])))
      .catch(() => {});
  }, [token]);

  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{
        style: {
          background: 'var(--card, #1a2340)',
          color: 'var(--text, #e2e8f0)',
          border: '1px solid var(--border, #1e2d4a)',
        }
      }} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="barriers" element={<Barriers />} />
          <Route path="restaurants" element={<Restaurants />} />
          <Route path="restaurants/:id/kitchen" element={<Kitchen />} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="wallet" element={<Wallet />} />
          <Route path="settings" element={<Settings />} />
          <Route path="announcements" element={<Announcements />} />
          <Route path="delivery" element={<Delivery />} />
          <Route path="reports" element={<Reports />} />
          <Route path="services" element={<Services />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return <Provider store={store}><AppInner /></Provider>;
}
